import { format, unwrapFunctionStore } from 'svelte-i18n';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const cloneViaCampaignManager = {
  element: '#campaigns > tbody > tr:nth-child(1)',
  popover: {
    title: 'Cloning via Campaign Manager',
    description:
      "To manage a campaign, click the <code><i class='os-icon-more-vertical'></i></code> button. You'll see a list of available actions, including editing, cloning, and deleting.",
    side: 'top',
    align: 'center',
    onNextClick: () => {
      const actionsMenuBtn = document.querySelector(
        '#campaigns > tbody > tr:nth-child(1) > td:nth-child(5) > div > span > i'
      );

      if (actionsMenuBtn) {
        actionsMenuBtn.click();

        GLOBAL_DRIVER_OBJECT.moveNext();
      }
    }
  }
};

export const cloneMenuOptions = {
  element: '#campaigns > tbody > tr:nth-child(1) > td:nth-child(5) > div > ul',
  popover: {
    title: 'Action Options',
    description: 'To clone a campaign, select <strong>&quot;Clone&quot;</strong> from the dropdown menu',
    side: 'left',
    align: 'center'
  }
};
